import { ReactNode } from 'react';

import styles from './form-box.module.scss';

export const FormBox = ({ children }: { children: ReactNode }) => {
	return <div className={styles['form-box']}>{children}</div>;
};

export default FormBox;
